import { Box, Flex } from "@chakra-ui/layout";
import { ChakraProps } from "@chakra-ui/react";

import { $ok } from "foundation-ts/commons";
import { UserBodyCommon, UserFlags } from "g1-commons/lib/doxecureTypes";
import { userName } from "g1-commons/lib/doxecureFunctions";

import { CardDescription } from "@components/Cards/CardDescription";
import { userRoleAndStatus } from "@utils/functions";
import { G1Icon } from "@utils/icons";
import { CustomItemType } from "@utils/TypesAndConstants";

export interface UserCardItem extends UserBodyCommon {
    avatarUrl?: string ;
    organizationName?: string ;
    userFlags?: UserFlags ;
}

export interface UserCardProps extends ChakraProps {
    item: UserCardItem ;
    itemStyle: CustomItemType ;
    displayIcon?: boolean ;
    displayOrganizationName?: boolean ;
    displayRole?: boolean ;
    isAdminCorporate?: boolean ,
    upDownButtons?: any ;
    onItemClick?: () => void ;
    onRemoveItemClick?: () => void ;
}

export const UserCard = (props: UserCardProps) => {
    const {
        itemStyle,
        item,
        displayIcon = false,
        displayOrganizationName = false,
        displayRole = false,
        isAdminCorporate,
        upDownButtons,
        onRemoveItemClick,
        onItemClick,
        ...rest
    } = props ;

    return (
        <Flex
            p="2"
            width="100%"
            minH="6em"
            borderTop={itemStyle.borderTop ?? "1px"}
            borderTopColor={itemStyle.borderTopColor ?? "inherit"}
            _hover={$ok(onItemClick) || $ok(onRemoveItemClick) ? itemStyle.hover : undefined}
            _focus={itemStyle.select}
            cursor={$ok(onItemClick) || $ok(onRemoveItemClick) ? "pointer" : "default"}
            onClick={onItemClick}
            {...rest}
        >
            {displayIcon && (
                <Box alignSelf="center" width="20px" paddingLeft="10px" color={itemStyle.iconColor ?? "inherit"}>{upDownButtons}</Box>
            )}
            <CardDescription width="100%" icon={item.avatarUrl} title={`${userName(item)}`} moreInfos={`${item.email}`}
                             organizationName={`${(displayOrganizationName && item.organizationName) || ""}`}
                             role={`${displayRole ? userRoleAndStatus(item.userFlags, isAdminCorporate) : ""}`} />
            {displayIcon && (
                <Box alignSelf="center" width="20%" display="flex" justifyContent="flex-end">
                    <Box margin="5%" alignSelf="center" color={itemStyle.iconColor ?? "inherit"}>
                        { $ok(onRemoveItemClick) ? <G1Icon.Minus size="20px" cursor="pointer" onClick={onRemoveItemClick} /> : <G1Icon.View size="20px" cursor="pointer" /> }
                    </Box>
                </Box>
            )}
        </Flex>
    ) ;
} ;